export default "__VITE_ASSET__BJOIPVxd__"